import { render, staticRenderFns } from "./VPSDetail.vue?vue&type=template&id=8ae02406&scoped=true"
import script from "./VPSDetail.vue?vue&type=script&lang=js"
export * from "./VPSDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ae02406",
  null
  
)

export default component.exports